import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CreateStoreProblem as SchemaCreateStoreProblem } from '../schemas/CreateStoreProblem';
import { type CreateStoreResponseBody as SchemaCreateStoreResponseBody } from '../schemas/CreateStoreResponseBody';
import { type DraftStore as SchemaDraftStore } from '../schemas/DraftStore';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const CreateStoreContentType = 'application/json' as const;
export type CreateStoreRequest = SchemaDraftStore;
export type CreateStoreResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful workflow creation
     */
    '200': {
        'application/json': SchemaCreateStoreResponseBody;
    };
    /**
     * @description Bad store creation request
     */
    '400': {
        'application/json': SchemaCreateStoreProblem;
    };
    /**
     * @description Unauthorized user
     */
    '401': {
        'application/json': SchemaCreateStoreProblem;
    };
};
export type CreateStoreResponseSuccess = CreateStoreResponses['200']['application/json'];
export type CreateStoreSearchParams = undefined;
export type CreateStorePathParameters = undefined;
export const CreateStoreUrl = '/stores' as const;
export const CreateStoreMethod = 'POST' as const;
export const getCreateStoreUrl = (_params?: CreateStorePathParameters) => CreateStoreUrl;
